import styled from "styled-components";

const MovieInfoLabel = styled.span`
  background: #e0e0e0;
  color: var(--text-primary);
  display: block;
  font-size: 1em;
  height: 2rem;
  line-height: 2rem;
  min-width: 2rem;
  padding: 0 0.5em;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  max-width: 6rem;

  body.theme-market &,
  body.theme-platinum & {
    color: var(--page-bg);
  }
`;

export default MovieInfoLabel;